module.exports = __webpack_public_path__ + "img/4_b-title.870be6fb.gif";